import { faGripDotsVertical } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { usePillDrag } from '../../../../context';
import classes from './DragHandle.module.css';

type DragHandlePropsType = {
  className?: string;
};

export const DragHandle: React.FC<DragHandlePropsType> = ({ className }) => {
  const { t } = useTranslation();
  const drag = usePillDrag();

  if (!drag) return null;

  const { attributes, listeners, setActivatorNodeRef } = drag;

  return (
    <button
      type="button"
      ref={setActivatorNodeRef}
      className={`${classes.dragHandle}${className ? ` ${className}` : ''}`}
      aria-label={t('QUERY_BUILDER.REORDER_HANDLE')}
      onClick={(event) => event.stopPropagation()}
      {...attributes}
      {...listeners}
    >
      <FontAwesomeIcon icon={faGripDotsVertical} size="xs" />
    </button>
  );
};
